import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { signOut } from 'firebase/auth'
import { auth } from '../../firebase'
import FamilySelector from '../family/FamilySelector'

export default function Navbar({ user, families, currentFamilyId, onFamilyChange, dark, onToggleDark }) {
  const location = useLocation()
  const handleSignOut = async () => {
    await signOut(auth)
  }

  const tabs = [
    { path: '/', label: 'Tree View' },
    { path: '/admin', label: 'Manage Family' },
    { path: '/settings', label: 'Settings' },
  ]

  return (
    <nav className="glass-navbar px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center group">
            <span className="self-center whitespace-nowrap text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 bg-clip-text text-transparent group-hover:scale-105 transition-transform">
              Kutumb
            </span>
          </Link>

          {user && currentFamilyId && (
            <FamilySelector
              families={families}
              currentFamilyId={currentFamilyId}
              onFamilyChange={onFamilyChange}
            />
          )}
        </div>

        <div className="flex items-center gap-4">
          {user && currentFamilyId && (
            <div className="flex items-center gap-1">
              {tabs.map(tab => (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                    location.pathname === tab.path
                      ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-md'
                      : 'text-gray-700 dark:text-gray-200 hover:bg-white/30 dark:hover:bg-gray-700/30'
                  }`}
                >
                  {tab.label}
                </Link>
              ))}
            </div>
          )}

          <button
            onClick={onToggleDark}
            className="rounded-xl p-2.5 bg-white/30 dark:bg-gray-700/30 backdrop-blur-md text-gray-700 dark:text-gray-200 hover:bg-white/50 dark:hover:bg-gray-700/50 border border-gray-300/30 dark:border-gray-600/30 transition-all duration-200 hover:scale-110"
            aria-label="Toggle dark mode"
          >
            {dark ? (
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
              </svg>
            )}
          </button>

          {user ? (
            <button onClick={handleSignOut} className="glass-btn-danger glass-btn-sm">
              Sign Out
            </button>
          ) : (
            <Link to="/auth" className="glass-btn-primary glass-btn-sm inline-block">
              Sign In / Sign Up
            </Link>
          )}
        </div>
      </div>
    </nav>
  )
}
